import React from 'react';
import CalendarDayCell from './CalendarDayCell';
import { toISODate } from './calendarConstants';

const WEEKDAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// Week and Fortnight share one overall height, so switching between them
// doesn't make the page jump: Week's one row stretches to fill it,
// Fortnight's two rows split it. A busy day can still grow it.
const GRID_HEIGHT = 292;

// weeks = 1 for the Week view, 2 for Fortnight (this week and next, one row
// each, so a Task can be dragged straight into the following week).
export function getWeekGridRange(anchorDate, weeks = 1) {
  const weekStart = new Date(anchorDate.getFullYear(), anchorDate.getMonth(), anchorDate.getDate() - anchorDate.getDay());
  const weekEnd = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + (7 * weeks) - 1);
  return { weekStart, weekEnd };
}

function CalendarWeekGrid({ anchorDate, itemsByDate, dragProps, weeks = 1 }) {
  const { weekStart } = getWeekGridRange(anchorDate, weeks);
  const rows = Array.from({ length: weeks }, (_, w) => Array.from(
    { length: 7 },
    (_, i) => new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + (w * 7) + i)
  ));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: weeks > 1 ? 10 : 0, minHeight: GRID_HEIGHT }}>
      {rows.map((days) => (
        <div key={toISODate(days[0])} style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', marginBottom: 4 }}>
            {days.map((date) => (
              <div key={toISODate(date)} style={{ fontSize: 11, fontWeight: 600, color: '#9aa5b5', textAlign: 'center', padding: '4px 0' }}>
                {WEEKDAY_LABELS[date.getDay()]} {date.getDate()}
              </div>
            ))}
          </div>
          <div style={{ flex: 1, display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)' }}>
            {days.map((date) => (
              <CalendarDayCell key={toISODate(date)} date={date} items={itemsByDate[toISODate(date)] || []} inCurrentMonth minHeight={0} {...dragProps} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default CalendarWeekGrid;
